/**
 * get origin for dev stores
 * @type {string}
 */
const currentOrigin = window.location.origin.indexOf('localhost') !== -1
|| window.location.origin.indexOf('myshopify') !== -1
  ? 'https://www.culturekings.com.au'
  : window.location.origin;

export const getCollection = async (handle) => {
  const url = `${currentOrigin}/collections/${handle}.json`;
  const response = await fetch(url, { method: 'GET' });
  return response.json();
};

export const getProduct = async (handle) => {
  const url = `${currentOrigin}/products/${handle}.json`;
  const response = await fetch(url, { method: 'GET' });
  return response.json();
};
